import styled from 'styled-components';
import flexColumns from '../../utils/flexColumns';

export default styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 59.5rem;
  margin: .5rem auto;
  padding: 0 1.5rem;
  font-size: .8125rem;
  color: #6c6c6c;

  ${({ columns }) => flexColumns(columns)};
`;
